import React, { useCallback } from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import MonetizationIcon from "../../../../../../assets/icons/MonitizationIcon";
import InlineIconButton from "../../../../../Buttons/InlineIconButton/InlineIconButton";
import StyledTooltip from "../../../../../StyledTooltip/StyledTooltip";

const CarrierOfferAction = React.memo(({ load, carrierId, active, actionCallback }) => {
  // Memoize the click handler to prevent recreation on every render
  const handleClick = useCallback(() => {
    actionCallback({ 
      action: "carrier-offer", 
      loadId: load.orderId, 
      carrierId: carrierId 
    });
  }, [actionCallback, load.orderId, carrierId]);

  return (
    <StyledTooltip title="Make Offer">
      <Box>
        <InlineIconButton
          onClick={handleClick}
          icon={MonetizationIcon}
          buttonColor={active ? "white" : "blue"}
        />
      </Box>
    </StyledTooltip>
  );
}, (prevProps, nextProps) => {
  // Custom comparison function - return true if props are equal (skip re-render)
  return (
    prevProps.load.orderId === nextProps.load.orderId &&
    prevProps.carrierId === nextProps.carrierId &&
    prevProps.active === nextProps.active &&
    prevProps.actionCallback === nextProps.actionCallback
  );
});

CarrierOfferAction.displayName = 'CarrierOfferAction';

CarrierOfferAction.propTypes = {
  load: PropTypes.object.isRequired,
  carrierId: PropTypes.string,
  active: PropTypes.bool,
  actionCallback: PropTypes.func.isRequired
};

export default CarrierOfferAction;